<template>
  <div class="stationAppointment">
    <NavBar v-if="sourceIsH5" :narBarTitle="workAreaSettingInfo.workAreaName" />

    <div class="appointmentStatusIconWrapper">
      <div class="typeStatusIcon">
        <div class="appointmentTypeStatusIcon">
          <span>
            {{ $t('流动工位') }}
          </span>
          <div class="appointmentFlowStatusIcon">
            <div class="appointmentStatusIcon" v-for="item in appointmentFlowStatusIcon" v-bind:key="item.name">
              <img :src="item.src" class="iconItem" />
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="appointmentTypeStatusIcon">
          <span>
            {{ $t('固定工位') }}
          </span>
          <div class="appointmentStatusIcon" v-for="item in appointmentFixedStatusIcon" v-bind:key="item.name">
            <img :src="item.src" class="iconItem" />
            {{ item.name }}
          </div>
          <div style="width: 1px;height: 10px;background: #B7BDC6;marginRight: 20px;"></div>
          <div class="appointmentStatusIcon">
            <div class="iconItemState"></div>
            {{ $t('有人') }}
          </div>
        </div>
      </div>
    </div>

    <!-- 工区显示 -->
    <div class="scaleMap" v-show="isShowScaleMap">
      <img :src="workAreaSettingInfo?.planeMap || defaultImg" />
      <div ref="demo2" :style="{ marginLeft: touchX + 25 + 'px' }" class="scaleMapBorder"></div>
      <div class="statinXYItem" v-for="statinXYItem in stationAppointmentList" :key="statinXYItem.id" :style="{
        top: (statinXYItem.top / scaleRatio) * clientRatio + 'px',
        left: (statinXYItem.left / scaleRatio) * clientRatio + 'px',
        width: (statinXYItem.width / scaleRatio) * clientRatio + 'px',
        height: (statinXYItem.height / scaleRatio) * clientRatio + 'px',
      }">
        <img class="statinXYItemIcon" :src="rednerIconUri(statinXYItem)" @click="handleClickStationXY(statinXYItem)" />
      </div>
    </div>

    <div id="container">
      <div id="scroll-content" ref="demo1">
        <img :src="workAreaSettingInfo?.planeMap || defaultImg" />
        <div class="statinXYItem" v-for="statinXYItem in stationAppointmentList" :key="statinXYItem.id" :style="{
          top: statinXYItem.top * clientRatio + 'px',
          left: statinXYItem.left * clientRatio + 'px',
          width: statinXYItem.width * clientRatio + 'px',
          height: statinXYItem.height * clientRatio + 'px',
        }">
          <img class="statinXYItemIcon" :src="rednerIconUri(statinXYItem)"
            @click="handleClickStationXY(statinXYItem)" />

          <!-- 显示有人/无人的状态 -->
          <div v-if="hasSensorId(statinXYItem)">
            <div :class="statinXYItem?.occupationStatus ? 'pulse' : ''" :style="{
              position: 'absolute',
              width: statinXYItem.width / 3 + 'px',
              height: statinXYItem.height / 3 + 'px',
              left:
                statinXYItem.width / 2 - statinXYItem.width / 3 / 2 + 'px',
              bottom:
                statinXYItem.height / 2 - statinXYItem.height / 3 / 2 + 'px',
              borderRadius: '50%',
              background: statinXYItem?.occupationStatus
                ? '#db0020'
                : '#6d9d13',
              border: '1px solid #FFFFFF',
            }" />
          </div>
        </div>
      </div>
    </div>

    <div class="appointmentContent appointmentContentStationName">
      <div class="appointmentCardWrapper">
        <div class="appointmentCard stationSelect">
          <div class="stationNameLabel">{{ $t('工位选择：') }}</div>
          <div class="stationName" v-if="curCheckedStation.stationName">
            {{ curCheckedStation.stationName }}
          </div>
          <div class="stationNameNoChecked" v-else>
            {{ $t('点击地图选择') }}
          </div>
        </div>
      </div>
    </div>

    <div class="appointmentContent">
      <div class="appointmentCardWrapper">
        <div class="appointmentCard">
          <!-- <div class="stationName">{{ curCheckedStation.stationName }}</div> -->
          <div class="appointmentTime">
            {{ $t('预约模式：')
            }}{{ this.appointmentName[appointmentConfig.mixMakeDay] }}
          </div>
          <div v-if="appointmentConfig.mixMakeDay === DAY">
            <render-day :appointmentConfig="appointmentConfig" :onChangeDate="onChangeDate"
              :checkedStationId="curCheckedStation.id" :dayStartTime="dayStartTime"
              :dayEndTime="dayEndTime"></render-day>
          </div>

          <div v-if="appointmentConfig.mixMakeDay === CUSTOM_TIME">
            <render-custom :appointmentConfig="appointmentConfig" :onChangeDate="onChangeDate"
              :checkedStationId="curCheckedStation.id"></render-custom>
          </div>

          <div v-if="appointmentConfig.mixMakeDay === HOURS">
            <render-hour :appointmentConfig="appointmentConfig" :onChangeDate="onChangeDate"
              :checkedStationId="curCheckedStation.id"></render-hour>
          </div>

          <div v-if="appointmentConfig.mixMakeDay === HALF_A_HOUR">
            <render-half-hour :appointmentConfig="appointmentConfig" :onChangeDate="onChangeDate"
              :checkedStationId="curCheckedStation.id"></render-half-hour>
          </div>
        </div>
      </div>

      <div class="appointmentPeoples">
        <div class="appointmentCardWrapper">
          <div class="appointmentCard">
            <div class="row bottomLine">
              <div class="appointmentPeopleLabel">
                {{ $t('预约人：')
                }}<span class="appointmentPeople">{{ renderUserName() }}</span>
              </div>
              <div class="replaceAppointment">
                <div class="replaceAppointmentLabel">{{ $t('代预约') }}</div>
                <van-switch v-model="checked" size="20" @change="hancleChangeSwitch" />
              </div>
            </div>

            <div class="row daiyuyren bottomLine" @click="isShowStaffList = true" v-if="checked">
              <div class="appointmentPeopleLabel">
                {{ $t('代预约人：')
                }}<span class="appointmentPeople">
                  {{
                    staffList.find(
                      (v) => v.value === curReplaceAppointmentPeople
                    )?.label
                  }}
                </span>
              </div>
              <img class="arrow" src="@/assets/images/icon_dropdown@2x.png" alt="" />
            </div>

            <div class="appointmentHistory" @click="showHistory = !showHistory">
              <div class="row">
                <div class="appointmentPeopleLabel">
                  {{ $t('历史预约信息') }}
                </div>
                <img :class="showHistory ? 'arrow90' : 'arrow'" src="@/assets/images/icon_dropdown@2x.png" alt="" />
              </div>

              <div class="appointmentHistoryCard" v-if="showHistory">
                <div class="appointmentHistoryItem" v-for="item in appointmentHistory" v-bind:key="item.name">
                  <span>{{ $t('预约人：') }}{{ item?.makeName }}</span>
                  <span>{{ $t('预约时间：') }}{{ item?.makeTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isShowDeadline">
        <div v-if="
          appointmentConfig.mixMakeDay === HALF_A_HOUR ||
          appointmentConfig.mixMakeDay === HOURS
        ">
          <div class="appointmentStartText">
            {{ $t('在当日') }}{{ appointmentStartTime }}{{ $t('时，开启')
            }}{{ lastDay }}{{ $t('日工位预约') }}
          </div>
        </div>
        <div v-else>
          <div class="appointmentStartText">
            {{ $t('在当日') }}{{ appointmentStartTime }}{{ $t('时，开启')
            }}{{ lastDay }}{{ $t('日工位预约') }}
          </div>
        </div>
      </div>
      <div class="stationOk">
        <van-button type="info" :disabled="(curCheckedStation.id !== 0 && curCheckedStation.id
          ? false
          : true) || isShowDeadline
          " round block @click="handleSubmit">
          {{
            curCheckedStation.id !== 0 && curCheckedStation.id
              ? $t('提交')
              : $t('请先选择工位')
          }}
        </van-button>
      </div>
    </div>

    <van-popup v-model="isShowStaffList" v-if="isShowStaffList" @click-overlay="replaceCancel" position="bottom"
      class="replaceAppointmentPopupWrapper">
      <div class="replaceAppointmentPopup">
        <div class="replace_title">
          <div @click="replaceCancel">{{ $t('取消') }}</div>
          <div>{{ $t('选择待预约人') }}</div>
          <div @click="replaceOk">{{ $t('确认') }}</div>
        </div>
        <div class="replace_list">
          <van-radio-group :value="replaceAppointmentPeopleChecked">
            <div v-for="item in staffList" :key="item.value">
              <van-radio @click="handleChangeReplace(item)" class="replaceAppointmentItem" :name="item.value">{{
                item.label }}</van-radio>
            </div>
          </van-radio-group>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="isShowConfit" v-if="isShowConfit" position="bottom" class="confirmAgainPopupWrapper">
      <div class="confirmAgainPopup">
        <div class="title">
          <div>{{ $t('预约时段确认') }}</div>
        </div>
        <div class="content">
          <div class="header">
            <van-cell-group>
              <van-cell :title="$t('工位名：')" :value="curCheckedStation.stationName" />
              <van-cell :title="$t('预约人：')" :value="renderUserName()" />
            </van-cell-group>
          </div>
          <div class="list">
            <div class="header">
              <van-cell-group>
                <van-cell :title="$t('所选时间段中以下时段已被预约')" />
              </van-cell-group>
            </div>

            <div class="content">
              <van-cell-group v-for="item in conficList" :key="item.value">
                <van-cell :title="`${moment(item.startTime).format(
                  'YYYY.MM.DD'
                )} ${moment(item.startTime).format('HH:mm')} - ${moment(
                  item.endTime
                ).format('HH:mm')}`" :value="$t('已被预约')" />
              </van-cell-group>
            </div>
          </div>
        </div>

        <div class="bottom">
          <van-button round type="default" @click="isShowConfit = false">{{
            $t('重新选择')
            }}</van-button>
          <van-button round type="info" @click="handleSubmit" :disabled="isShowDeadline">{{ $t('仍然预约') }}</van-button>
        </div>
      </div>
    </van-popup>

    <van-dialog v-model="showAppointmentSuccess" show-cancel-button class="appointmentSuccessWrapper"
      :showConfirmButton="false" :showCancelButton="false">
      <div class="appointmentSuccessContent">
        <img :src="require('@/assets/images/success_icon.png')" class="appointmentSuccess" />
        <span class="okText">{{ $t('工位预约成功') }}</span>
        <span class="okCount">
          <div class="countDownText">
            <van-count-down class="okCount" :time="timeCountDown" format="ss" @finish="goToRoute" />
            <span class="countDownTextUnit">s</span>
          </div>
        </span>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import RenderDay from './components/RenderDay'
import RenderCustom from './components/RenderCustom'
import RenderHour from './components/RenderHour'
import RenderHalfHour from './components/RenderHalfHour'

import {
  queryAppointmentSeetingConfig,
  queryAppointmentStaion,
  updateAppointmentStaion,
  staffDepartmentStaff,
  queryAppointmentHistory,
  queryDisableDate,
  queryConfitAppointments,
  getStationHoldUpTime,
} from '@/services/api'
import Vue from 'vue'
import dayjs from 'dayjs'
import moment from 'moment'
import { EasyScroller } from 'easyscroller'
import {
  transformStationXY,
  getStatusIconUrl,
  getWorkAreaStationScale,
  uniqueFunc,
  flatOrganization,
  fixNewDate,
} from '@/utils/utils'
import bubbleSelectIcon from '@/assets/images/bubble-select.png'
import circleSelectIcon from '@/assets/images/circle-select.png'
import squareSelectIcon from '@/assets/images/square-select.png'
import fixedIcon from '@/assets/images/fixed.png' // 固定工位
import ellipse1Icon from '@/assets/images/bubble-1.png' // 气泡空闲状态
import ellipse2Icon from '@/assets/images/bubble-3.png' // 气泡部分空闲
import ellipse3Icon from '@/assets/images/bubble-2.png' // 气泡约满
import ellipse4Icon from '@/assets/images/bubble-4.png' // 气泡不可用
import fixed1Icon from '@/assets/images/fixed-1.png' // 固定工位：已分配
import fixed2Icon from '@/assets/images/fixed-2.png' // 固定工位：未分配
import {
  Calendar,
  Dialog,
  Toast,
  ActionSheet,
  Tab,
  Tabs,
  Search,
  Popup,
  PullRefresh,
  List,
  Loading,
  Field,
  Button,
  DatetimePicker,
  Icon,
  Switch,
  Radio,
  RadioGroup,
  Picker,
  CountDown,
  Cell,
  CellGroup,
} from 'vant'
import { formatDateYMDHMS, mergeTimeRanges } from './utils'
import { getWebSocketOrigin } from '@/utils/utils'
import { debounce } from 'lodash'

Vue.use(Calendar)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Popup)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Field)
Vue.use(Button)
Vue.use(DatetimePicker)
Vue.use(Icon)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Picker)
Vue.use(CountDown)
Vue.use(Cell)
Vue.use(CellGroup)
export default {
  name: 'StationAppointmentSetting',
  components: {
    NavBar,
    RenderDay,
    RenderCustom,
    RenderHour,
    RenderHalfHour,
  },
  data() {
    return {
      defaultImg: require('@/assets/images/default_image.png'),
      sourceIsH5: true,
      user: this.user,
      workAreaSettingInfo: {}, // 空间信息
      stationAppointmentList: [], // 工位图上预约信息的坐标信息
      appointmentConfig: {}, // web端配置的工位预约时间断类型信息

      checked: false, // 是否开启代预约人
      isShowStaffList: false,

      startDate: new Date(fixNewDate(this.$route.params.startTime)), // 开始日期（年月日-天）
      endDate: new Date(fixNewDate(this.$route.params.endTime)), // 结束日期（年月日-天）

      dayStartTime: '',
      dayEndTime: '',

      staffList: [], // 员工信息列表
      HALF_A_HOUR: 'HALF_A_HOUR', // '0.5小时',
      HOURS: 'HOURS', // '1小时',
      // HALF_A_DAY: 'HALF_A_DAY', // '半天',
      DAY: 'DAY', // '天'
      CUSTOM_TIME: 'CUSTOM_TIME', // '天'
      // diffHours: 0, // 开始时间与结束时间相差多少小时
      curCheckedStation: {},
      touchStartX: 0,
      touchEndX: 0,
      touchX: 0,
      scaleRatio: 2.6, // 元素宽高等缩小比例
      submitLoading: false,
      isShowScaleMap: true, // 是否显示缩略图
      timer: null,
      appointmentFlowStatusIcon: [
        { name: this.$t('全部空闲'), color: '#8ED30C', src: ellipse1Icon },
        { name: this.$t('部分空闲'), color: '#FFA200', src: ellipse2Icon },
        { name: this.$t('约满'), color: '#E34444', src: ellipse3Icon },
        { name: this.$t('不可用'), color: '#B7B7B7', src: ellipse4Icon },
      ],
      appointmentFixedStatusIcon: [
        { name: this.$t('已分配'), color: '#8ED30C', src: fixed1Icon },
        { name: this.$t('未分配'), color: '#8ED30C', src: fixed2Icon },
      ],

      clientRatio: document.body.clientWidth / 375, // 以375为模版，匹配在不同屏幕上的缩放比例
      appointmentHistory: [], // 当天已经预约的信息

      replaceAppointmentPeopleChecked: '', // 切换代预约人，未进行保存的数据
      curReplaceAppointmentPeople: null, // 点击确定保存代预约人
      showAppointmentSuccess: false, // 工位预约成功后提醒弹窗
      timeCountDown: 1000 * 3,
      appointmentName: {
        HALF_A_HOUR: this.$t('按半小时预约'),
        HOURS: this.$t('按小时预约'),
        DAY: this.$t('按天预约'),
        CUSTOM_TIME: this.$t('自定义时段预约'),
      },
      showHistory: false,
      rangeDateForSubmit: [],
      isShowConfit: false,
      conficList: [],
      submitParams: [],
      moment,
      isShowDeadline: false, //是否未到达可预约时间
      appointmentStartTime: '', // 可以约最后一天的时间
      lastDay: '', // 最后一天的日期
    }
  },
  methods: {
    hasSensorId(item) {
      return item && item.sensorId && item.occupationStatus
    },
    // 查询员工信息
    async queryDepartmentStaff() {
      const res = await staffDepartmentStaff({
        companyId: this.user.companyId,
      })
      let list = []
      let _options = []
      list = flatOrganization(res) // 获取所有员工信息
      list.forEach((v) => {
        _options.push({
          label: v.staffName,
          value: v.staffId,
        })
      })
      this.staffList = uniqueFunc(_options, 'value')
    },
    renderUserName() {
      return this.user?.name
    },
    /**
     * date: 日期
     * workspaceId: 空间
     */
    async queryAppointmentStaionList(startTime, endTime) {
      const { workAreaId, workspaceId } = this.$route.params

      const res = await queryAppointmentStaion({
        companyId: this.user.companyId,
        startTime,
        endTime,
        workspaceId,
        source: '1',
        areaId: workAreaId,
      })

      if (!res.data) {
        this.stationAppointmentList = []
        return
      }
      if (this.appointmentStartTime) {
        let lastDay = dayjs(endTime).format('YYYY-MM-DD 23:59:59')
        if (
          dayjs(lastDay).isBefore(
            dayjs().add(
              this.appointmentConfig
                ? parseInt(this.appointmentConfig.maxMakeDay) - 1
                : 20,
              'day'
            ),
            'day'
          )
        ) {
          this.isShowDeadline = false
          this.lastDay = ''
        } else {
          if (
            dayjs().isBefore(
              dayjs().format('YYYY-MM-DD') + ' ' + this.appointmentStartTime,
              'minute'
            )
          ) {
            this.isShowDeadline = true
            this.lastDay = dayjs(lastDay).format('YYYY.MM.DD')
          }
        }
      }
      let _stationXYList = []
      let stationIds = [] // 保存绑定了传感器的工位

      this.workAreaSettingInfo =
        res.data.stationReserveList &&
        res.data.stationReserveList[0].workAreaSetting
      if (
        res.data.stationReserveList &&
        res.data.stationReserveList[0].stationStatusList
      ) {
        res.data.stationReserveList[0].stationStatusList.forEach((element) => {
          _stationXYList.push({
            id: element.id,
            type: 'img',
            src: getStatusIconUrl(element.iconType, element.makeState, element),
            width: getWorkAreaStationScale(
              element.wide ? Number(element.wide) : 0, 4
            ),
            height: getWorkAreaStationScale(
              element.height ? Number(element.height) : 0, 4
            ),
            top: getWorkAreaStationScale(
              transformStationXY(element.coordinate).y, 4
            ),
            left: getWorkAreaStationScale(
              transformStationXY(element.coordinate).x, 4
            ),
            stationName: element.stationName,
            // stationState: element.stationState,
            stationType: element.stationType,
            makeState: element.makeState,
            userName: element.userName,
            iconType: element.iconType,
            sensorId: element?.sensorId,
          })

          element?.sensorId && stationIds.push(element.id)
        })
      }

      this.stationAppointmentList = _stationXYList

      stationIds.length > 0 && this.queryStationOccupationStatus()
    },
    /**
     * 查询工位的有人/无人状态
     */
    async queryStationOccupationStatus() {
      let ids = []

      this.stationAppointmentList.forEach((station) => {
        ids.push(Number(station.id))
      })

      if (ids?.length) {
        const status = await getStationHoldUpTime(ids)
        let newCanvasList = []
        this.stationAppointmentList.forEach((v) => {
          const curOccupationStatus = status?.[v.id]
            ? JSON.parse(status?.[v.id])
            : { state: false }
          newCanvasList.push({
            ...v,
            occupationStatus: curOccupationStatus?.state,
          })
        })
        this.stationAppointmentList = newCanvasList
      }
    },
    async queryInit() {
      const { workspaceId, startTime } = this.$route.params
      let _stationSettingConfig = await queryAppointmentSeetingConfig(
        workspaceId
      )
      //mock
      this.appointmentConfig = _stationSettingConfig.data
      this.appointmentStartTime = _stationSettingConfig.data?.timePointSet
      if (_stationSettingConfig?.data?.mixMakeDay == 'DAY') {
        let flowDayRuleTime = _stationSettingConfig?.data?.flowDayRuleTime
        this.dayStartTime = flowDayRuleTime?.split('-')[0]
        this.dayEndTime = flowDayRuleTime?.split('-')[1]
      }
    },
    handleTouchMove(e) {
      this.timer && clearTimeout(this.timer)
      this.changeIsShowScaleMap()

      this.touchEndX = e.changedTouches[0].pageX.toFixed(1)

      const distanceX = this.touchStartX - e.changedTouches[0].pageX.toFixed(1)
      let _distanceX = distanceX / this.scaleRatio
      if (_distanceX > 34) {
        _distanceX = 34
      } else if (_distanceX < -34) {
        _distanceX = -34
      }
      this.touchX = _distanceX
    },
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].pageX.toFixed(1)
    },
    handleTouchEnd(e) { },
    hancleChangeSwitch(flag) {
      this.checked = flag
      this.isShowStaffList = flag
      if (!flag) {
        this.curReplaceAppointmentPeople = null
        this.replaceAppointmentPeopleChecked = null
      }
    },

    async handleClickStationXY(item) {
      if (item.makeState == 'MAKE_UNUSABLE') {
        item.makeState == 'MAKE_UNUSABLE' && Toast.fail(this.$t('该工位不可用'))
        return
      }
      if (item.stationType == 'PERMANENT') {
        Toast.fail(this.$t('固定工位不可预约'))
        return
      }

      if (this.appointmentConfig.mixMakeDay == 'DAY' && dayjs(this.startDate).isSame(dayjs(), 'day') && dayjs().isSameOrAfter(dayjs(dayjs().format('YYYY-MM-DD') + ' ' + this.dayEndTime + ':00'))) {
        Toast.fail(this.$t('已超过系统设置的可工位可使用时段，暂不可预定'))
        return
      }
      this.curCheckedStation = item

      this.handlQueryAppointmentHistory(
        dayjs(this.startDate).format('YYYY-MM-DD 00:00:00'),
        dayjs(this.endDate).format('YYYY-MM-DD 23:59:59'),
        this.curCheckedStation.id
      )
    },
    // 渲染工位图形，并显示选中工位效果图
    rednerIconUri(renderItem) {
      let curUri = ''
      if (this.curCheckedStation.id === renderItem.id) {
        // 预约图中选中的图标需要进行选中图片替换
        if (renderItem.iconType === 'ellipse') {
          // 气泡形状
          curUri = bubbleSelectIcon
        } else if (renderItem.iconType === 'circle') {
          // 圆形状
          curUri = circleSelectIcon
        } else if (renderItem.iconType === 'square') {
          // 正方形形状
          curUri = squareSelectIcon
        }
      } else {
        // 预约图中没有点击，不需要进行替换
        curUri = renderItem.src
      }
      return curUri
    },

    async queryDisables() {
      const res = await queryDisableDate({
        stationId: this.curCheckedStation.id,
        startTime: `${moment(this.startDate).format('YYYY-MM-DD')} 00:00:00`,
        endTime: `${moment(this.endDate).format('YYYY-MM-DD')} 23:59:59`,
        type: this.appointmentConfig.mixMakeDay,
      })
      let sortByStartTime = []
      // 1. 按照开始时间进行生序
      sortByStartTime = res?.data.sort(
        (a, b) => moment(a.startTime).valueOf() - moment(b.startTime).valueOf()
      )
      // 2. 相邻的时间段进行合并
      let newDateList = mergeTimeRanges(sortByStartTime)

      return newDateList
    },
    /**
     * 自定义时段的配置范围是否变化，原先可能12:00-14:00,现在改为了12:00-15:00。会出现时段冲突的情况，此情况不许进行再次预约。
     * @param appointmentConfig
     * @param disabledList
     * @returns
     */
    confIsChange(appointmentConfig, disabledList) {
      let isChange = false
      const oldAppointmentConfig =
        appointmentConfig?.customPeriod && appointmentConfig.customPeriod !== ''
          ? JSON.parse(appointmentConfig.customPeriod)
          : []

      for (const key in disabledList) {
        const item = disabledList[key]
        const formatTime = `${moment(item.startTime).format('HH:mm')}-${moment(
          item.endTime
        ).format('HH:mm')}`

        const isMate = oldAppointmentConfig.find((v) => v.value === formatTime) // 是否存在不匹配的自定义时段，只要有就可以再次进行预约

        if (!isMate) {
          isChange = true
          break
        }
      }
      return isChange
    },
    /**
     * 自定义时段的预约时段是否存在有效提交的时段。
     * 预约冲突的时段没有重复的存在。只要存在一个完全没有时段冲突的，那还是要要支持再次预约的。
     * @param submitParams
     * @param disabledList
     * @returns
     */
    isExitEffectOne(submitParams, disabledList) {
      let has = false
      for (let param of submitParams) {
        const isHasEffect = disabledList.find(
          (disabled) =>
            (moment(param.startTime).isBefore(disabled.startTime, 'second') &&
              moment(param.endTime).isBefore(disabled.startTime, 'second')) ||
            (moment(param.startTime).isAfter(disabled.endTime, 'second') &&
              moment(param.endTime).isAfter(disabled.endTime, 'second'))
        )
        if (isHasEffect) {
          has = true
          break
        }
      }
      return has
    },
    async handleSubmit() {
      this.submitLoading = true
      if (!this.curCheckedStation.id) {
        this.submitLoading = false
        Toast.fail(this.$t('未选择工位'))
        return
      }

      let params = []
      this.rangeDateForSubmit.forEach((date) => {
        params.push({
          companyId: this.user.companyId,
          workspaceId: this.$route.params.workspaceId,
          workAreaId: this.$route.params.workAreaId,
          startTime: date.startTime,
          endTime: date.endTime,
          manipulatorId: this.user.id, //  当前预约人id
          subscriberId: this.curReplaceAppointmentPeople
            ? [this.curReplaceAppointmentPeople]
            : [this.user.id], // 代预约人id
          stationId: this.curCheckedStation.id,
        })
      })
      const originParams = [...params]
      // if (this.rangeDateForSubmit && this.rangeDateForSubmit.length && this.appointmentStartTime) {
      //   let lastDayLine = this.rangeDateForSubmit[this.rangeDateForSubmit.length - 1]
      //   let lastDay = lastDayLine.endTime.split(' ')[0]
      //   if (dayjs(lastDay).isBefore(dayjs().add(this.appointmentConfig ? parseInt(this.appointmentConfig.maxMakeDay) - 1 : 20, 'day'), 'day')) {
      //     this.isShowDeadline = false
      //     this.lastDay = ''
      //   } else {
      //     if (dayjs().isBefore(dayjs().format('YYYY-MM-DD') + ' ' + this.appointmentStartTime, 'minute')) {
      //       this.isShowDeadline = true
      //       this.lastDay = dayjs(lastDay).format('YYYY.MM.DD')
      //       return
      //     }
      //   }
      // }
      // 用于再次确认
      if (this.isShowConfit) {
        const bookedDates = await this.queryDisables()

        // 过滤掉已经预约的时间
        params = params.filter((v) => {
          const exitDay = bookedDates.find(
            (date) =>
              date.startTime === v.startTime && date.endTime === date.endTime
          )
          if (exitDay) {
            return false
          } else {
            return true
          }
        })

        // 过滤掉有冲突的时间段
        if (this.appointmentConfig?.mixMakeDay === 'CUSTOM_TIME') {
          params = params.filter((v) => {
            const exitDay = this.conficList.find(
              (date) =>
                moment(v.startTime).isBetween(
                  date.startTime,
                  date.endTime,
                  'minute'
                ) ||
                moment(v.endTime).isBetween(
                  date.startTime,
                  date.endTime,
                  'minute'
                )
            )
            if (exitDay) {
              return false
            } else {
              return true
            }
          })
        }
      }

      console.log('---params:', JSON.parse(JSON.stringify(params)))
      this.submitParams = params

      // 冲突时间将选择的params过滤掉完了，导致的params为空，提示重复
      if (
        originParams.length !== 0 &&
        params.length === 0 &&
        this.conficList.length !== 0 &&
        this.conficList.length >= originParams.length
      ) {
        Toast(this.$t('时段存在重复，请重新填写'))
        return
      }

      // 只是时间段为空的情况，禁止提交
      let isOk = true
      for (const item of params) {
        if (dayjs(item.startTime).isSame(item.endTime, 'minute')) {
          isOk = false
          break
        }
      }
      if (!isOk) {
        Toast(this.$t('时段存在重复，请重新填写'))
        return
      }

      // 时间段为空，禁止提交
      if (params.length === 0) {
        Toast(this.$t('时段不能为空，请重新填写'))
        return
      }

      const res = await updateAppointmentStaion(
        params,
        this.isShowConfit ? true : false
      )
      if (res.msg === this.$t('成功')) {
        this.showAppointmentSuccess = true
        await this.queryAppointmentStaionList(dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss'), dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss'))
        this.submitLoading = false
      } else {
        // 半小时&小时弹全局提醒，不进行二次确认；
        if (
          this.appointmentConfig?.mixMakeDay === 'HALF_A_HOUR' ||
          this.appointmentConfig?.mixMakeDay === 'HOURS'
        ) {
          Toast(res.msg)
          return
        }

        // 天&自定义不进行全局提醒，进行二次确认
        if (
          this.appointmentConfig?.mixMakeDay === 'CUSTOM_TIME' ||
          this.appointmentConfig?.mixMakeDay === 'DAY'
        ) {
          // 出现冲突的四种情况
          if (
            res.msg === this.$t('该工位已被占用') ||
            res.msg === this.$t('所选工位不在可用范围内') ||
            res.msg === this.$t('工位数不足') ||
            res.msg === this.$t('暂无可用工位')
            // || res.msg === this.$t('此时间段不可预约') ||
            // res.msg === this.$t('当天已有页约记录，无法预约')
          ) {
            // 查询冲突的信息
            const confs = await queryConfitAppointments(
              this.rangeDateForSubmit,
              {
                // makeStaffId: this.user.id,
                workspaceId: this.$route.params.workspaceId,
                stationId: this.curCheckedStation.id,
              }
            )
            let list = []
            confs?.data.forEach((v) => {
              list = [...list, ...v.makeTimeFrameInfos]
            })

            // 天情况下，只选了一天情况下，且当天预约满了，禁止提交
            if (
              this.appointmentConfig?.mixMakeDay === 'DAY' &&
              params.length === 1 &&
              list.length === 1
            ) {
              Toast(res.msg)
              return
            }

            const isExit = this.isExitEffectOne(params, list)

            // 自定义时段，出现的冲突时段，和最新配置的时段不一致，禁止在再次预约
            const isChange = this.confIsChange(this.appointmentConfig, list)
            if (
              this.appointmentConfig?.mixMakeDay === 'CUSTOM_TIME' &&
              isChange &&
              !isExit
            ) {
              Toast(res.msg)
              return
            }

            this.conficList = list
            list?.length > 0 && (this.isShowConfit = true)
          } else {
            Toast.fail(res.msg)
          }
        }
      }
    },

    updateRouteParam() {
      this.curCheckedStation.id = this.$route.params.stationId
      this.curCheckedStation.stationName = this.$route.params.stationName
    },
    changeIsShowScaleMap() {
      this.isShowScaleMap = true
      this.timer = setTimeout(() => {
        this.isShowScaleMap = false
        clearTimeout(this.timer)
        this.timer = null
      }, 1000)
    },
    /**
     * 查询当天预约的信息（随机预约和时间类型是 DAY 的不查询）
     */
    async handlQueryAppointmentHistory(startTime, endTime, stationId) {
      try {
        const res = await queryAppointmentHistory({
          startTime,
          endTime,
          stationId,
          workspaceId: this.$route.params.workspaceId,
          workAreaId: this.$route.params.workAreaId,
        })
        this.appointmentHistory = res.data
        // mock
        // this.appointmentHistory = [{ makeName: 'lisi', makeTime: '12:00' }]
      } catch (error) { }
    },
    replaceCancel() {
      this.isShowStaffList = false
      if (!this.curReplaceAppointmentPeople) {
        this.checked = false
      }
      this.replaceAppointmentPeopleChecked = this.curReplaceAppointmentPeople
    },
    replaceOk() {
      if (
        this.replaceAppointmentPeopleChecked !== 0 &&
        !this.replaceAppointmentPeopleChecked
      ) {
        // 未进行人员选择，禁止点击确认
        Toast.fail(this.$t('请选择代预约人'))
        return
      }
      this.curReplaceAppointmentPeople = this.replaceAppointmentPeopleChecked
      this.isShowStaffList = false
      this.checked = true
    },
    handleChangeReplace(item) {
      this.replaceAppointmentPeopleChecked = item.value
    },
    goToRoute() {
      this.$router.back()
    },
    async onChangeDate(type, sdate, edate, rangeDateForSubmit) {
      // if (type === 'start') {
      this.startDate = sdate
      // } else if (type === 'end') {
      this.endDate = edate
      // }
      this.rangeDateForSubmit = rangeDateForSubmit
      this.handlQueryAppointmentHistory(
        dayjs(sdate).format('YYYY-MM-DD 00:00:00'),
        dayjs(edate).format('YYYY-MM-DD 23:59:59'),
        this.curCheckedStation.id
      )
      await this.queryAppointmentStaionList(dayjs(sdate).format('YYYY-MM-DD HH:mm:ss'), dayjs(edate).format('YYYY-MM-DD HH:mm:ss'))
      if (this.appointmentStartTime) {
        let lastDay = dayjs(edate)
        // type === 'end' ? dayjs(edate) : dayjs(sdate)
        lastDay = lastDay.format('YYYY-MM-DD 23:59:59')
        if (
          dayjs(lastDay).isBefore(
            dayjs().add(
              this.appointmentConfig
                ? parseInt(this.appointmentConfig.maxMakeDay) - 1
                : 20,
              'day'
            ),
            'day'
          )
        ) {
          this.isShowDeadline = false
          this.lastDay = ''
        } else {
          if (
            dayjs().isBefore(
              dayjs().format('YYYY-MM-DD') + ' ' + this.appointmentStartTime,
              'minute'
            )
          ) {
            this.isShowDeadline = true
            this.lastDay = dayjs(lastDay).format('YYYY.MM.DD')
          }
        }
      }
    },
    connectWebSocket() {
      let url = `${getWebSocketOrigin()}/newworkwss/ws/${this.user.id}`
      this.webSocket = new WebSocket(url)

      this.pendingUpdates = [] // 🌟存放短时间收到的工位变化数据
      this.debouncedApplyUpdates = debounce(() => {
        if (this.pendingUpdates.length === 0) return

        const updates = this.pendingUpdates
        this.pendingUpdates = [] // 清空

        const newCanvasList = this.stationAppointmentList.map((v) => {
          const update = updates.find((u) => u.stationId === v.id)
          if (update) {
            return { ...v, occupationStatus: update.state }
          }
          return v
        })

        this.stationAppointmentList = newCanvasList
      }, 100) // 合并时间，100ms批处理一次

      this.webSocket.onopen = () => {
        console.log('websocket连接成功')
      }
      this.webSocket.onclose = () => {
        this.webSocket.close()
        console.log('websocket连接已关闭')
      }
      this.webSocket.onmessage = (res) => {
        if (res.data.indexOf(this.$t('成功')) != -1) return
        try {
          const message = JSON.parse(res.data)
          if (message?.msgType == 'stationHoldUpTime') {
            this.pendingUpdates.push(message)
            this.debouncedApplyUpdates()
          }
        } catch (ignore) { }
      }
      this.webSocket.onerror = (res) => {
        console.log('websocket连接失败')
        console.log(res)
      }
    },
  },
  watch: {},
  computed: {
    touchXP: function () {
      return this.touchStartX - this.touchEndX
    },
  },
  mounted() {
    this.height = document.body.scrollHeight - 135
    this.user = JSON.parse(localStorage.getItem('user'))
    this.updateRouteParam()
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
    this.$refs.demo1.addEventListener('touchstart', this.handleTouchStart)
    this.$refs.demo1.addEventListener('touchmove', this.handleTouchMove)
    this.$refs.demo1.addEventListener('touchend', this.handleTouchEnd)
    this.$refs.demo1.addEventListener('resize', (e) => console.log('resize', e))

    const element = document.querySelector('#scroll-content')
    this.scroller = new EasyScroller(element, {
      scrollingX: true,
      scrollingY: true,
      zooming: true,
      minZoom: 1,
      maxZoom: 3.0,
      zoomLevel: 1.4,
      // bouncing: false,
      // scrollingComplete: this.scrollingComplete,
      // getScroller: this.getScroller,
    })
    this.queryDepartmentStaff()
    this.queryInit()
    this.changeIsShowScaleMap()

    this.startDate = new Date(fixNewDate(this.$route.params.startTime)) // 开始日期（年月日-天）
    this.endDate = new Date(fixNewDate(this.$route.params.endTime)) // 结束日期（年月日-天）
    this.queryAppointmentStaionList(dayjs(this.startDate).format('YYYY-MM-DD HH:mm:ss'), dayjs(this.endDate).format('YYYY-MM-DD HH:mm:ss'))

    this.connectWebSocket()
  },
  beforeDestroy() {
    this.scroller.destroy()
    this.timer && clearTimeout(this.timer)
    this.webSocket && this.webSocket.close()
  },
}
</script>
<style lang="less" scoped>
.stationAppointment {
  .appointmentStatusIconWrapper {
    display: flex;
    flex-direction: row;
    padding: 16px;

    .typeStatusIcon {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }

    .appointmentTypeStatusIcon {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .appointmentFlowStatusIcon {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #1e2329;
        line-height: 22px;
        text-align: left;
        font-style: normal;
        margin-right: 8px;
      }
    }

    .appointmentStatusIcon {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #1e2329;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      margin-right: 20px;

      .iconItem {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }

      .iconItemState {
        width: 11px;
        height: 11px;
        background: #FF4D4F;
        border-radius: 50%;
        margin-right: 4px;
        border: 1px solid #FFFFFF;
      }
    }

    .appointmentTypeStatusIcon .appointmentStatusIcon:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .scaleMap {
    width: 100px;
    position: absolute;
    // margin-bottom: -100px;
    z-index: 1;

    .scaleMapBorder {
      position: absolute;
      top: 0;
      width: 40px;
      bottom: 0;
      border: 1px dashed #f60000;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}

#container {
  // background-color: #fff;
  height: 328px;
  // height: 500px;
  margin: 0 auto 0 auto;
  overflow: hidden;
  width: 100%;
  position: relative;

  #scroll-content {
    position: relative;
    // width: 845px; // web端宽度
    // height: 520px; // web端高度
    // 宽高比例 845/520 = 1.625
    width: 260px; // h5宽度
    margin-top: 50px;
    margin-left: 5px;

    img {
      width: 100%
    }
  }
}

.statinXYItem {
  position: absolute;

  .statinXYItemIcon {
    width: 100%;
    height: 100%;
    vertical-align: top;
  }
}

.appointmentContent {
  padding: 10px 0 30px;
  background: #f5f5f5;

  .appointmentCardWrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;

    .appointmentCard {
      width: 375px;
      // height: 317px;
      background: #fefffe;
      border-radius: 6px;
      padding: 8px 16px;

      .stationNameLabel {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: #1e2329;
      }

      .stationName {
        font-size: 16px;
        font-weight: bold;
        color: #1e2329;
      }

      .appointmentTime {
        padding: 8px 0 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #b7bdc6;
        border-bottom: 1px solid rgba(234, 236, 239, 0.5);
      }

      .dateForm {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 8px;

        .firstDateForm {
          width: 184px;
          height: 32px;
          line-height: 32px;
          text-indent: 8px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d1d1d1;
          position: relative;

          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        .secondDateForm {
          width: 120px;
          height: 32px;
          line-height: 32px;
          text-indent: 5px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #d1d1d1;
          position: relative;

          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }

        .secondDateFormDisable {
          background: #ccc;
        }

        .arrow-down {
          position: absolute;
          right: 5px;
          top: 6px;
        }
      }

      .totalHours {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-bottom: 8px;
      }

      .appointmentPeople {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 8px;
      }

      .replaceAppointment {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .replaceAppointmentLabel {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin-right: 6px;
          line-height: inherit;
        }
      }

      .appointmentHistory {
        .appointmentHistoryCard {
          padding: 10px 0;
          overflow-y: auto;
          max-height: 200px;

          .appointmentHistoryItem {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #646b73;
            line-height: 18px;
            margin-bottom: 8px;
          }

          & span:nth-child(1) {
            margin-right: 20px;
          }
        }
      }
    }
  }
}

.appointmentContentStationName {
  padding-bottom: 0;

  .appointmentCardWrapper {
    padding-bottom: 0;
  }

  .appointmentCard {
    display: flex;
  }

  .stationNameNoChecked {
    font-size: 16px;
    color: #b7bdc6;
  }
}

.appointmentPeoples {
  .appointmentCard {
    .appointmentPeopleLabel {
      .appointmentPeople {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
}

.arrow {
  width: 20px;
  height: 20px;
  transform: rotate(0);
  transition: transform 0.5s ease;
}

.arrow90 {
  width: 20px;
  height: 20px;
  transform: rotate(90deg);
  transition: transform 0.5s ease;
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}

.bottomLine {
  border-bottom: 1px solid #e2e8f6;
}

.stationOk {
  padding: 0 14px;

  .checkIndexStation {
    text-align: center;
    padding: 3px 0;
  }
}

.replaceAppointmentPopupWrapper {
  background: #ffffff;
  border-radius: 16px 16px 0px 0px;
  padding-top: 10px;

  .replaceAppointmentPopup {
    padding: 43px 16px 10px;
    max-height: 420px;
    position: relative;

    .replaceAppointmentItem {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #1e2329;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      padding: 16px 0;
      border-bottom: 1px solid #e2e8f6;
    }

    .van-radio-group {
      padding: 10px 20px;
    }

    .replace_title {
      width: 93%;
      position: absolute;
      height: 43px;
      line-height: 43px;
      top: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      div {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #474d57;
      }

      & div:nth-child(2) {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #1e2329;
        line-height: 24px;
        text-align: center;
        font-style: normal;
      }

      & div:nth-child(3) {
        color: #1890ff;
      }
    }

    .replace_list {
      max-height: 420px;
      overflow-y: scroll;
    }

    .van-radio-group {
      padding: 0px;
    }
  }
}

.checkedStaffList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  .checkedStaffListItem {
    padding: 2px 4px;
    font-size: 14px;
    color: #666666;
  }
}

.startTimeHoursWrapper {
  // /deep/ .van-picker__columns .van-picker-column:nth-child(2){
  //   display: none;
  // }
}

.appointmentSuccessWrapper {
  width: 296px;
  height: 192px;

  .appointmentSuccessContent {
    width: 296px;
    height: 192px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .okText {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin: 4px 0;
    }

    .okCount {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }

  .appointmentSuccess {
    width: 88px;
    height: 88px;
  }
}

.confirmAgainPopupWrapper {
  border-radius: 16px 16px 0px 0px;
  background: #f2f2f6;

  .confirmAgainPopup {
    .title {
      width: 375px;
      height: 56px;
      line-height: 56px;
      text-align: center;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #1e2329;
      font-style: normal;
    }

    .content {
      .header {
        .van-cell__title {
          font-family: PingFangSC, PingFang SC;
          font-size: 16px;
          color: #1e2329;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          flex: none;

          /deep/span {
            display: inline-block;
            width: 220px;
          }
        }

        .van-cell__value {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #1e2329;
          line-height: 24px;
          text-align: left;
          font-style: normal;
        }
      }
    }

    .list {
      margin-top: 6px;

      .header {
        .van-cell__title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #f6465d;
          line-height: 22px;
          text-align: left;
          font-style: normal;

          /deep/span {
            display: inline-block;
            width: 300px;
          }
        }
      }

      .content {
        max-height: 420px;
        overflow-y: scroll;

        .van-cell__title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #1e2329;
          line-height: 24px;
          text-align: left;
          font-style: normal;

          /deep/span {
            display: inline-block;
            width: 260px;
          }
        }

        .van-cell__value {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #f6465d;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          text-align: right;
        }
      }
    }

    .bottom {
      margin: 20px 0 10px;
      display: flex;
      justify-content: space-between;
      padding: 0 8px;

      .van-button--round {
        width: 170px;
        height: 48px;
        border-radius: 24px;
        border: 1px solid #b7bdc6;

        .van-button__text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 18px;
          color: #1e2329;
          line-height: 24px;
          text-align: center;
          font-style: normal;
        }
      }

      & .van-button:nth-child(2) {
        .van-button__text {
          color: #ffffff;
        }
      }
    }
  }
}

.countDownText {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .countDownTextUnit {
    margin-left: 2px;
    margin-bottom: 2px;
  }
}

.stationSelect {
  padding: 19px !important;
}

.appointmentStartText {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #646b73;
  margin-bottom: 4px;
}

.pulse {
  animation: pulseScale 1s infinite ease-in-out;
}

@keyframes pulseScale {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    /* 略微放大 */
    opacity: 0.6;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
